import { render } from "./DesignContact.vue?vue&type=template&id=908b0eda&scoped=true"
import script from "./DesignContact.vue?vue&type=script&lang=js"
export * from "./DesignContact.vue?vue&type=script&lang=js"

import "./DesignContact.vue?vue&type=style&index=0&id=908b0eda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908b0eda"]])

export default __exports__